import {
  Build,
  DashboardRounded as DashboardRoundedIcon,
  BusinessRounded as BusinessRoundedIcon,
  RocketLaunch as DataRequestIcon,
  CloudDownloadRounded as ExportsIcon,
  NetworkCheck as DataAlertsIcon,
  CloudSync as DeploymentIcon,
  MenuBook as DocsIcon,
  Assignment as ModelIcon,
} from '@mui/icons-material';
import { AUTH_LEVELS } from '../../redux/constants/roles';

const DEFAULT_NAV_ITEMS = [
  {
    text: 'Live System',
    items: [
      {
        to: '/explore/buildings',
        text: 'Buildings',
        icon: BusinessRoundedIcon,
      },
      {
        to: '/deployments',
        text: 'Deployments',
        icon: DeploymentIcon,
      },
      {
        to: '/data-alerts',
        text: 'Data Alerts',
        icon: DataAlertsIcon,
      },
      {
        to: '/dashboard',
        text: 'Dashboard',
        icon: DashboardRoundedIcon,
      },
    ],
  },
  {
    text: 'Configuration',
    items: [
      {
        to: '/buildings/new',
        text: 'Launcher',
        icon: DataRequestIcon,
        authLevel: AUTH_LEVELS.ORG_MANAGER,
      },
      {
        to: '/staging',
        text: 'Staging',
        icon: Build,
      },
    ],
  },
  {
    text: 'Data',
    items: [
      {
        to: '/data-model',
        text: 'Data Model',
        icon: ModelIcon,
      },
      {
        to: '/exports',
        text: 'Data Export',
        icon: ExportsIcon,
      },
      {
        to: '/docs',
        text: 'API & Docs',
        icon: DocsIcon,
      },
    ],
  },
];

export default DEFAULT_NAV_ITEMS;
